import { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'sonner';
import { subscribeOwnerOrders } from '@/services/orderService';
import type { Order } from '@/types/order';

export function useNewOrderNotifier(ownerId?: string): void {
  const { t } = useTranslation();
  const seenRef = useRef<Set<string> | null>(null);

  useEffect(() => {
    if (!ownerId) return;
    seenRef.current = null;
    const unsub = subscribeOwnerOrders(ownerId, (orders: Order[]) => {
      if (seenRef.current === null) {
        seenRef.current = new Set(orders.map((o) => o.orderId));
        return;
      }
      for (const o of orders) {
        if (o.status === 'new' && !seenRef.current.has(o.orderId)) {
          toast.success(t('orders.newOrderBadge'), {
            description: `${o.customerName} — ${o.items.length}× ${t('orders.detail.items').toLowerCase()}`,
            action: {
              label: t('common.continue'),
              onClick: () => {
                window.location.assign(`/dashboard/orders/${o.orderId}`);
              },
            },
          });
        }
        seenRef.current.add(o.orderId);
      }
    });
    return () => unsub();
  }, [ownerId, t]);
}
